export const permissions = [
  "admin_pg_gestao_locais",
  "admin_pg_gestao_usuarios",
  "admin_recurso_cadastro_usuario",
];

export const CARGO_CODES = {
  SUPERINTENDENTE: "219.840.000",
  GERENTE_VENDAS: "219.840.001",
  CORRETOR: "219.840.002",
  GERENTE_GERAL: "219.840.003",
  VENDEDOR: "219.840.004",
  SUPERVISOR: "219.840.005",
  ESPECIALISTA_PRODUTO: "219.840.006",
  RECEPCIONISTA: "219.840.007",
  ASSISTENTE_COMERCIAL: "219.840.009",
  GERENTE_COMERCIAL: "219.840.010",
  DIRETOR: "219.840.011",
  COORDENADOR_CIA: "219.840.012",
  GERENTE_CIA: "219.840.013",
  COORDENADOR_PRODUTO: "219.840.014",
} as const;

export type CargoCode = (typeof CARGO_CODES)[keyof typeof CARGO_CODES];
